<span>[{{ reference().referenceNumber }}]</span>
{{ authors() }}.

@if (reference().title) {
  <strong>
    @if (titleLink()) {
      <a style="text-decoration: underline" target="_blank" [href]="titleLink()">{{ reference().title?.trim() }}</a>
    } @else {
      {{ reference().title?.trim() }}
    }
  </strong>
}
{{ details() }}
